import { render } from "./AddQuestionView.vue?vue&type=template&id=fcbee37a&scoped=true"
import script from "./AddQuestionView.vue?vue&type=script&lang=js"
export * from "./AddQuestionView.vue?vue&type=script&lang=js"

import "./AddQuestionView.vue?vue&type=style&index=0&id=fcbee37a&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fcbee37a"]])

export default __exports__